<template>
  <div class="english">
    <viewer :images="urls">
      <template v-for="(a,i) in urls">
        <!-- <img  v-lazy="a" v-if="i<=4" class="hj-image-lazy"> -->
        <img  :src="a" v-if="i<=4" class="hj-image-lazy">
      </template>
    </viewer>
  </div>
</template>

<script>
export default {
  name: 'english',
  components: {},
  data() {
    return{
      urls: [
        require(`../../assets/images/eg/0.png`),
        require(`../../assets/images/eg/1.png`),
        require(`../../assets/images/eg/2.png`),
        require(`../../assets/images/eg/3.png`),
        require(`../../assets/images/eg/4.png`),
      ],
      urls2:[]
    }
  },
  mounted() {
    const imgTotal=4;
    for (let i = 0; i < imgTotal; i++) {
      let url = require(`../../assets/images/eg/${i}.png`);
      this.urls.push(url);
    }

  }
}
</script>

<style scoped lang='less'>
.english{
  max-width: 950px;
  margin:0 auto;
  img{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// english.vue?788f38ef